import { PreviewHostImp } from './preview-host-imp';
let previewHost = null;
const signalingUrl = window.__designerSession.signalingUrl;
if (signalingUrl) {
    // Generate a unique ID for this instance of the designer. We use this ID to identify ourselves
    // when communicating with previews that are embedded in this designer instance.
    const instanceId = Math.random().toString(36).substring(2, 9); // it doesn't need to be a uuid, just something random-ish
    // console.log(`DesignerBootstrap: creating PreviewHost (instance id: ${instanceId}).`);
    previewHost = new PreviewHostImp(signalingUrl, window.__designerSession, window.__projectMetaData, instanceId);
    window.__previewManager = previewHost;
}
else {
    console.error('Unable to initialize: signalingUrl is missing.');
}
// Handle Webpack Hot Updates during development
// if (module.hot) { // 'if (module.hot)' will be replaced with 'if (true)'
//     module.hot.accept();
//     module.hot.dispose((data) => {
//         console.log('DesignerBootstrap: a hot update was accepted, disposing master.');
//         if (previewHost)
//             previewHost.leave();
//         previewHost = null;
//         // The following creates a duplicate instance of PreviewHost, we should not do this.
//         //     console.log('DesignerBootstrap: creating new PreviewHost');
//         //     previewHost = new PreviewHost(signalingUrl, previewChunkId);
//         //     // Create a new instance of the master, otherwise our WebRTC updates don't work
//         //     window.__previewHost = previewHost;
//     });
// }
//# sourceMappingURL=connector-host.js.map